import styled from 'styled-components';
import { media, mediaQuery } from '../../../common/styles/styleUtil';

export const Wrapper = styled.div`
  width: 100%;
  @media (${mediaQuery.tablet}) {
    padding: 0 24px;
  }
  ${media.xs`
    padding: 0 16px;
  `};
`;

export const Top = styled.h1`
  font-size: 32px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333f48;
  ${media.xs`
    font-size: 24px;
  `}
`;

export const Middle = styled.h2`
  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333f48;
  margin-top: 4px;
  ${media.xs`
    font-size: 16px;
  `}
`;

export const BottomWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ${media.xs`
    flex-direction: column;
    justify-content: space-around;
  `};
`;
export const LastUpdated = styled.div`
  font-size: 12px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #333f48;
`;

export const CommentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Comment = styled.div`
  margin-left: 32px;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2b6ed2;
  span {
    ${media.xs`
      display: none;
    `};
  }
  ${media.xs`
    text-align: right;
    margin-left: 0;
  `};
`;

export const Shared = styled.div`
  display: none;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #697684;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  ${media.xs`
    margin-top: 11px;
  `};
`;
